// // // src/pages/public/WeeklyCalendar.jsx
// // import React, { useEffect, useMemo, useState } from "react";
// // import {
// //   collection,
// //   query,
// //   where,
// //   orderBy,
// //   onSnapshot,
// //   Timestamp,
// // } from "firebase/firestore";
// // import { db } from "../../config/firebase";

// // /**
// //  * Weekly calendar (Mon–Sun) 8:00 → 22:00
// //  * - Grid resolution: 15 minutes (so :00, :15, :30, :45 align perfectly)
// //  * - Left time labels show every 30 minutes in 12-hour format
// //  * - Subscribes to Firestore bookings for the visible week
// //  * - Handles both single-service and multi-service bookings
// //  */

// // const START_HOUR = 8;   // 8 AM
// // const END_HOUR   = 22;  // 10 PM
// // const SLOT_MIN   = 15;  // grid resolution
// // const ROW_HEIGHT = 28;  // px per 15-min slot

// // /* --- simple mobile hook (same as other pages) --- */
// // function useIsMobile(breakpoint = 768) {
// //   const [isMobile, setIsMobile] = useState(
// //     typeof window !== "undefined" ? window.innerWidth <= breakpoint : false
// //   );

// //   useEffect(() => {
// //     const handler = () => {
// //       if (typeof window === "undefined") return;
// //       setIsMobile(window.innerWidth <= breakpoint);
// //     };
// //     window.addEventListener("resize", handler);
// //     return () => window.removeEventListener("resize", handler);
// //   }, [breakpoint]);

// //   return isMobile;
// // }

// // export default function WeeklyCalendar() {
// //   const [weekStart, setWeekStart] = useState(getMonday(new Date()));
// //   const [bookings, setBookings] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const isMobile = useIsMobile();

// //   // All grid rows count (15-min increments)
// //   const rowsCount = useMemo(
// //     () => ((END_HOUR - START_HOUR) * 60) / SLOT_MIN,
// //     []
// //   );

// //   // Monday .. Sunday (local)
// //   const days = useMemo(
// //     () => Array.from({ length: 7 }, (_, i) => addDays(weekStart, i)),
// //     [weekStart]
// //   );

// //   // Labels for the left column (every 30 minutes)
// //   const timeLabels = useMemo(
// //     () => makeHalfHourLabels(START_HOUR, END_HOUR),
// //     []
// //   );

// //   // Subscribe to Firestore for the current week
// //   useEffect(() => {
// //     if (!db) return;

// //     // Range: [Mon 00:00 local -> UTC], [next Mon 00:00 local -> UTC]
// //     const startUTC = toUTCMidnight(weekStart);
// //     const endUTC = toUTCMidnight(addDays(weekStart, 7));

// //     const q = query(
// //       collection(db, "bookings"),
// //       where("start", ">=", Timestamp.fromDate(startUTC)),
// //       where("start", "<", Timestamp.fromDate(endUTC)),
// //       orderBy("start", "asc")
// //     );

// //     setLoading(true);
// //     const unsub = onSnapshot(
// //       q,
// //       (snap) => {
// //         const items = snap.docs
// //           .map((d) => {
// //             const x = d.data() || {};
// //             // Robust timestamp -> Date
// //             const start =
// //               x.start?.toDate?.() ?? (x.start ? new Date(x.start) : null);
// //             const end =
// //               x.end?.toDate?.() ?? (x.end ? new Date(x.end) : null);
// //             if (
// //               !(start instanceof Date) ||
// //               isNaN(start) ||
// //               !(end instanceof Date) ||
// //               isNaN(end)
// //             ) {
// //               return null; // skip malformed
// //             }

// //             // Service title
// //             let title = "Service";
// //             if (Array.isArray(x.services) && x.services.length) {
// //               const names = x.services
// //                 .map((s) => s?.name || "Service")
// //                 .filter(Boolean);
// //               title =
// //                 names.length > 1
// //                   ? `${names[0]} (+${names.length - 1})`
// //                   : names[0];
// //             } else if (x.serviceName || x.service) {
// //               title = x.serviceName || x.service;
// //             }

// //             // Staff
// //             const sid = x.staffId || x.employeeId || "na";
// //             const sname =
// //               x.staffName ||
// //               x.employeeName ||
// //               (sid === "any" ? "Any staff" : "Staff");

// //             return {
// //               id: d.id,
// //               title,
// //               staff: { id: sid, name: sname },
// //               _start: start,
// //               _end: end,
// //               color: colorForEmployee(sid),
// //             };
// //           })
// //           .filter(Boolean);
// //         setBookings(items);
// //         setLoading(false);
// //       },
// //       (err) => {
// //         console.error("Bookings subscription failed:", err);
// //         setLoading(false);
// //       }
// //     );

// //     return () => unsub();
// //   }, [weekStart]);

// //   const calendarWrapStyle = isMobile
// //     ? sx.calendarWrapMobile
// //     : sx.calendarWrapDesktop;

// //   const gridStyle = {
// //     ...sx.grid,
// //     ...(isMobile ? sx.gridMobile : {}),
// //     gridTemplateColumns: `140px repeat(7, 1fr)`,
// //     gridTemplateRows: `40px repeat(${rowsCount}, ${ROW_HEIGHT}px)`,
// //   };

// //   return (
// //     <div style={sx.screen}>
// //       <div style={sx.header}>
// //         <div style={sx.brand}>Weekly Schedule</div>
// //         <div style={sx.nav}>
// //           <button
// //             style={sx.navBtn}
// //             onClick={() => setWeekStart(addDays(weekStart, -7))}
// //           >
// //             ← Prev
// //           </button>
// //           <button
// //             style={sx.navBtn}
// //             onClick={() => setWeekStart(getMonday(new Date()))}
// //           >
// //             This Week
// //           </button>
// //           <button
// //             style={sx.navBtn}
// //             onClick={() => setWeekStart(addDays(weekStart, 7))}
// //           >
// //             Next →
// //           </button>
// //         </div>
// //       </div>

// //       <div
// //         style={{
// //           ...sx.weekLabel,
// //           ...(isMobile ? sx.weekLabelMobile : {}),
// //         }}
// //       >
// //         {fmt(days[0], { month: "short", day: "numeric" })} –{" "}
// //         {fmt(days[6], { month: "short", day: "numeric", year: "numeric" })}
// //         {loading ? " • loading…" : ""}
// //       </div>

// //       <div style={calendarWrapStyle}>
// //         {/* grid is scrollable horizontally on mobile */}
// //         <div style={gridStyle}>
// //           {/* Top-left corner cell */}
// //           <div style={{ gridColumn: 1, gridRow: 1 }} />

// //           {/* Day headers */}
// //           {days.map((d, i) => (
// //             <div
// //               key={i}
// //               style={{ ...sx.dayHeader, gridColumn: i + 2, gridRow: 1 }}
// //             >
// //               <div style={{ fontWeight: 800, fontSize: isMobile ? 12 : 14 }}>
// //                 {fmt(d, { weekday: "short" })}{" "}
// //                 <span style={{ fontWeight: 600, opacity: 0.85 }}>
// //                   {fmt(d, { month: "short", day: "numeric" })}
// //                 </span>
// //               </div>
// //             </div>
// //           ))}

// //           {/* Time labels (every 30 minutes) aligned to 15-min grid rows */}
// //           {timeLabels.map(({ label, row }, idx) => (
// //             <div
// //               key={idx}
// //               style={{ ...sx.timeCell, gridColumn: 1, gridRow: row }}
// //             >
// //               {label}
// //             </div>
// //           ))}

// //           {/* Grid background cells */}
// //           {days.map((_, c) =>
// //             Array.from({ length: rowsCount }).map((__, r) => (
// //               <div
// //                 key={`cell-${c}-${r}`}
// //                 style={{
// //                   gridColumn: c + 2,
// //                   gridRow: r + 2,
// //                   borderBottom: "1px solid #eef2f7",
// //                   borderRight: c < 6 ? "1px solid #f3f5f9" : "none",
// //                 }}
// //               />
// //             ))
// //           )}

// //           {/* Booking blocks */}
// //           {bookings.map((b) => {
// //             const pos = placeBooking(b, weekStart);
// //             if (pos.col < 0) return null;
// //             return (
// //               <div
// //                 key={b.id}
// //                 title={`${b.title} • ${b.staff.name}`}
// //                 style={{
// //                   ...sx.booking,
// //                   gridColumn: pos.col,
// //                   gridRow: `${pos.rowStart} / ${pos.rowEnd}`,
// //                   background: b.color || "#5c5470",
// //                   ...(isMobile ? sx.bookingMobile : {}),
// //                 }}
// //               >
// //                 <div style={sx.bTitle}>{b.title}</div>
// //                 <div style={sx.bMeta}>
// //                   {fmtTime(b._start)} – {fmtTime(b._end)}
// //                 </div>
// //                 <div style={sx.bStaff}>{b.staff.name}</div>
// //               </div>
// //             );
// //           })}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// // /* ---------------- Placement & Labels ---------------- */

// // function placeBooking(b, weekStart) {
// //   if (!b || !(b._start instanceof Date) || !(b._end instanceof Date))
// //     return { col: -1 };
// //   const s = b._start;
// //   const e = b._end;
// //   if (isNaN(s) || isNaN(e)) return { col: -1 };

// //   // Which day inside the displayed week?
// //   const dayIndex = Math.floor(
// //     (stripTime(s) - stripTime(weekStart)) / (24 * 3600 * 1000)
// //   );
// //   if (dayIndex < 0 || dayIndex > 6) return { col: -1 };

// //   // Convert times into grid line numbers (15-min slots)
// //   const startSlots = Math.round(minutesSinceStart(s) / SLOT_MIN);
// //   const endSlots = Math.round(minutesSinceStart(e) / SLOT_MIN);

// //   const rowStart = 2 + startSlots; // +2 because row 1 is header, row 2 is 8:00
// //   const rowEnd = 2 + endSlots;
// //   const col = dayIndex + 2; // +2 because col 1 is labels, col 2 is Monday

// //   return { col, rowStart, rowEnd };
// // }

// // function minutesSinceStart(d) {
// //   return (d.getHours() - START_HOUR) * 60 + d.getMinutes();
// // }

// // // Build 30-min labels and which grid row each should be rendered at
// // function makeHalfHourLabels(fromHour, toHour) {
// //   const labels = [];
// //   const base = stripTime(new Date());
// //   for (let h = fromHour; h < toHour; h++) {
// //     for (let m of [0, 30]) {
// //       const dt = new Date(base);
// //       dt.setHours(h, m, 0, 0);
// //       const minutes = (h - START_HOUR) * 60 + m;
// //       const row = 2 + Math.round(minutes / SLOT_MIN); // 15-min grid
// //       labels.push({ label: fmtTime(dt), row });
// //     }
// //   }
// //   // add the final 10:00 PM label
// //   const end = new Date(base);
// //   end.setHours(toHour, 0, 0, 0);
// //   labels.push({
// //     label: fmtTime(end),
// //     row: 2 + Math.round(((toHour - START_HOUR) * 60) / SLOT_MIN),
// //   });
// //   return labels;
// // }

// // /* ---------------- Date Utilities ---------------- */

// // function getMonday(d) {
// //   const x = new Date(d);
// //   const day = (x.getDay() + 6) % 7; // Mon=0
// //   x.setDate(x.getDate() - day);
// //   x.setHours(0, 0, 0, 0);
// //   return x;
// // }
// // function addDays(d, n) {
// //   const x = new Date(d);
// //   x.setDate(x.getDate() + n);
// //   return x;
// // }
// // function stripTime(d) {
// //   const x = new Date(d);
// //   x.setHours(0, 0, 0, 0);
// //   return x;
// // }
// // function fmt(d, opt) {
// //   return new Intl.DateTimeFormat(undefined, opt).format(d);
// // }

// // // Force 12-hour display (1:45 PM) to match your UI
// // function fmtTime(d) {
// //   return new Intl.DateTimeFormat(undefined, {
// //     hour: "numeric",
// //     minute: "2-digit",
// //     hour12: true,
// //   }).format(d);
// // }

// // // Convert local date (00:00) to a UTC-midnight Date
// // function toUTCMidnight(localDate) {
// //   const y = localDate.getFullYear();
// //   const m = localDate.getMonth();
// //   const d = localDate.getDate();
// //   return new Date(Date.UTC(y, m, d, 0, 0, 0, 0));
// // }

// // /* ---------------- Colors ---------------- */

// // const PALETTE = [
// //   "#6b60a1",
// //   "#c98f7a",
// //   "#7aa3c9",
// //   "#86b17e",
// //   "#a967a0",
// //   "#5c5470",
// // ];
// // function colorForEmployee(empId) {
// //   const key = String(empId || "na");
// //   let hash = 0;
// //   for (let i = 0; i < key.length; i++)
// //     hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
// //   return PALETTE[hash % PALETTE.length];
// // }

// // /* ---------------- Styles ---------------- */

// // const sx = {
// //   screen: {
// //     minHeight: "100vh",
// //     background: "#f8fafc",
// //     fontFamily:
// //       "Work Sans, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
// //   },
// //   header: {
// //     maxWidth: 1200,
// //     margin: "0 auto",
// //     padding: "16px 20px",
// //     display: "flex",
// //     justifyContent: "space-between",
// //     alignItems: "center",
// //   },
// //   brand: { fontSize: 20, fontWeight: 800, color: "#5c5470" },
// //   nav: { display: "flex", gap: 8 },
// //   navBtn: {
// //     background: "#e7e9ee",
// //     border: 0,
// //     borderRadius: 8,
// //     padding: "8px 10px",
// //     cursor: "pointer",
// //     fontWeight: 700,
// //     color: "#475569",
// //   },
// //   weekLabel: {
// //     maxWidth: 1200,
// //     margin: "0 auto",
// //     padding: "0 20px 10px",
// //     fontWeight: 700,
// //     color: "#0f172a",
// //   },
// //   weekLabelMobile: {
// //     padding: "0 16px 8px",
// //     fontSize: 13,
// //   },

// //   calendarWrapDesktop: {
// //     maxWidth: 1200,
// //     margin: "0 auto",
// //     padding: "0 20px 40px",
// //   },
// //   calendarWrapMobile: {
// //     maxWidth: "100%",
// //     margin: "0 auto",
// //     padding: "0 12px 32px",
// //     overflowX: "auto",
// //   },

// //   grid: {
// //     position: "relative",
// //     display: "grid",
// //     background: "#fff",
// //     border: "1px solid #e5e7eb",
// //     borderRadius: 12,
// //     overflow: "hidden",
// //     boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
// //   },
// //   gridMobile: {
// //     minWidth: 900,
// //   },

// //   dayHeader: {
// //     display: "flex",
// //     alignItems: "center",
// //     justifyContent: "center",
// //     borderLeft: "1px solid #eef2f7",
// //     background: "#fafbfe",
// //     color: "#0f172a",
// //   },
// //   timeCell: {
// //     paddingRight: 8,
// //     paddingLeft: 8,
// //     fontSize: 11,
// //     color: "#64748b",
// //     display: "flex",
// //     alignItems: "center",
// //     justifyContent: "flex-end",
// //     borderBottom: "1px solid #eef2f7",
// //     background: "#fafbfe",
// //   },
// //   booking: {
// //     position: "relative",
// //     margin: "2px 6px",
// //     borderRadius: 8,
// //     color: "#fff",
// //     padding: "8px 10px",
// //     boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
// //     overflow: "hidden",
// //   },
// //   bookingMobile: {
// //     padding: "6px 8px",
// //   },
// //   bTitle: { fontSize: 12, fontWeight: 800, lineHeight: 1.2 },
// //   bMeta: { fontSize: 11, opacity: 0.95, marginTop: 2 },
// //   bStaff: {
// //     fontSize: 11,
// //     fontWeight: 700,
// //     marginTop: 6,
// //     paddingTop: 6,
// //     borderTop: "1px dashed rgba(255,255,255,0.5)",
// //   },
// // };


// // src/pages/public/WeeklyCalendar.jsx
// import React, { useEffect, useMemo, useState } from "react";
// import {
//   collection,
//   query,
//   where,
//   orderBy,
//   onSnapshot,
//   Timestamp,
// } from "firebase/firestore";
// import { db } from "../../config/firebase";

// /**
//  * Weekly calendar (Mon–Sun) 8:00 → 22:00
//  * - Grid resolution: 15 minutes (so :00, :15, :30, :45 align perfectly)
//  * - Left time labels show every 30 minutes in 12-hour format
//  * - Subscribes to Firestore bookings for the visible week
//  * - Handles both single-service and multi-service bookings
//  */

// const START_HOUR = 8;   // 8 AM
// const END_HOUR   = 22;  // 10 PM
// const SLOT_MIN   = 15;  // grid resolution
// const ROW_HEIGHT = 28;  // px per 15-min slot

// /* --- simple mobile hook (same as other pages) --- */
// function useIsMobile(breakpoint = 768) {
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== "undefined" ? window.innerWidth <= breakpoint : false
//   );

//   useEffect(() => {
//     const handler = () => {
//       if (typeof window === "undefined") return;
//       setIsMobile(window.innerWidth <= breakpoint);
//     };
//     window.addEventListener("resize", handler);
//     return () => window.removeEventListener("resize", handler);
//   }, [breakpoint]);

//   return isMobile;
// }

// export default function WeeklyCalendar() {
//   const [weekStart, setWeekStart] = useState(getMonday(new Date()));
//   const [bookings, setBookings] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const isMobile = useIsMobile();

//   // which day is selected on mobile (0=Mon..6=Sun)
//   const [selectedDayIndex, setSelectedDayIndex] = useState(() => {
//     const today = new Date();
//     const monday = getMonday(today);
//     const diff =
//       (stripTime(today) - stripTime(monday)) / (24 * 3600 * 1000);
//     return diff >= 0 && diff < 7 ? Math.floor(diff) : 0;
//   });

//   // All grid rows count (15-min increments)
//   const rowsCount = useMemo(
//     () => ((END_HOUR - START_HOUR) * 60) / SLOT_MIN,
//     []
//   );

//   // Monday .. Sunday (local)
//   const days = useMemo(
//     () => Array.from({ length: 7 }, (_, i) => addDays(weekStart, i)),
//     [weekStart]
//   );

//   // Labels for the left column (every 30 minutes)
//   const timeLabels = useMemo(
//     () => makeHalfHourLabels(START_HOUR, END_HOUR),
//     []
//   );

//   // Subscribe to Firestore for the current week
//   useEffect(() => {
//     if (!db) return;

//     // Range: [Mon 00:00 local -> UTC], [next Mon 00:00 local -> UTC]
//     const startUTC = toUTCMidnight(weekStart);
//     const endUTC = toUTCMidnight(addDays(weekStart, 7));

//     const q = query(
//       collection(db, "bookings"),
//       where("start", ">=", Timestamp.fromDate(startUTC)),
//       where("start", "<", Timestamp.fromDate(endUTC)),
//       orderBy("start", "asc")
//     );

//     setLoading(true);
//     const unsub = onSnapshot(
//       q,
//       (snap) => {
//         const items = snap.docs
//           .map((d) => {
//             const x = d.data() || {};
//             // Robust timestamp -> Date
//             const start =
//               x.start?.toDate?.() ?? (x.start ? new Date(x.start) : null);
//             const end =
//               x.end?.toDate?.() ?? (x.end ? new Date(x.end) : null);
//             if (
//               !(start instanceof Date) ||
//               isNaN(start) ||
//               !(end instanceof Date) ||
//               isNaN(end)
//             ) {
//               return null; // skip malformed
//             }

//             // Service title
//             let title = "Service";
//             if (Array.isArray(x.services) && x.services.length) {
//               const names = x.services
//                 .map((s) => s?.name || "Service")
//                 .filter(Boolean);
//               title =
//                 names.length > 1
//                   ? `${names[0]} (+${names.length - 1})`
//                   : names[0];
//             } else if (x.serviceName || x.service) {
//               title = x.serviceName || x.service;
//             }

//             // Staff
//             const sid = x.staffId || x.employeeId || "na";
//             const sname =
//               x.staffName ||
//               x.employeeName ||
//               (sid === "any" ? "Any staff" : "Staff");

//             return {
//               id: d.id,
//               title,
//               staff: { id: sid, name: sname },
//               _start: start,
//               _end: end,
//               color: colorForEmployee(sid),
//             };
//           })
//           .filter(Boolean);
//         setBookings(items);
//         setLoading(false);
//       },
//       (err) => {
//         console.error("Bookings subscription failed:", err);
//         setLoading(false);
//       }
//     );

//     return () => unsub();
//   }, [weekStart]);

//   // compute layout (including overlap columns)
//   const laidOutBookings = useMemo(
//     () => layoutBookings(bookings, weekStart),
//     [bookings, weekStart]
//   );

//   const calendarWrapStyle = isMobile
//     ? sx.calendarWrapMobile
//     : sx.calendarWrapDesktop;

//   const gridStyle = {
//     ...sx.grid,
//     ...(isMobile ? sx.gridMobile : {}),
//     gridTemplateColumns: isMobile
//       ? `100px 1fr`              // time + selected day
//       : `140px repeat(7, 1fr)`,  // time + 7 days
//     gridTemplateRows: `40px repeat(${rowsCount}, ${ROW_HEIGHT}px)`,
//   };

//   const handleThisWeek = () => {
//     const today = new Date();
//     const monday = getMonday(today);
//     setWeekStart(monday);
//     const diff =
//       (stripTime(today) - stripTime(monday)) / (24 * 3600 * 1000);
//     setSelectedDayIndex(diff >= 0 && diff < 7 ? Math.floor(diff) : 0);
//   };

//   // which day indices to render (desktop: 0..6, mobile: only selected)
//   const dayIndices = isMobile ? [selectedDayIndex] : days.map((_, i) => i);

//   return (
//     <div style={sx.screen}>
//       <div style={sx.header}>
//         <div style={sx.brand}>Schedule</div>
//         <div style={sx.nav}>
//           <button
//             style={sx.navBtn}
//             onClick={() => setWeekStart(addDays(weekStart, -7))}
//           >
//             ← Prev
//           </button>
//           <button style={sx.navBtn} onClick={handleThisWeek}>
//             Today
//           </button>
//           <button
//             style={sx.navBtn}
//             onClick={() => setWeekStart(addDays(weekStart, 7))}
//           >
//             Next →
//           </button>
//         </div>
//       </div>

//       {/* mobile day strip (Teams-style) */}
//       {isMobile && (
//         <div style={sx.dayStrip}>
//           {days.map((d, i) => {
//             const active = i === selectedDayIndex;
//             return (
//               <button
//                 key={i}
//                 style={{
//                   ...sx.dayChip,
//                   ...(active ? sx.dayChipActive : {}),
//                 }}
//                 onClick={() => setSelectedDayIndex(i)}
//               >
//                 <div style={sx.dayChipDow}>
//                   {fmt(d, { weekday: "short" }).slice(0, 1)}
//                 </div>
//                 <div style={sx.dayChipDate}>{d.getDate()}</div>
//               </button>
//             );
//           })}
//         </div>
//       )}

//       <div
//         style={{
//           ...sx.weekLabel,
//           ...(isMobile ? sx.weekLabelMobile : {}),
//         }}
//       >
//         {fmt(days[0], { month: "short", day: "numeric" })} –{" "}
//         {fmt(days[6], { month: "short", day: "numeric", year: "numeric" })}
//         {loading ? " • loading…" : ""}
//       </div>

//       <div style={calendarWrapStyle}>
//         {/* grid is scrollable horizontally on mobile */}
//         <div style={gridStyle}>
//           {/* Top-left corner cell */}
//           <div style={{ gridColumn: 1, gridRow: 1 }} />

//           {/* Day headers */}
//           {isMobile
//             ? (() => {
//                 const i = selectedDayIndex;
//                 const d = days[i];
//                 return (
//                   <div
//                     style={{ ...sx.dayHeader, gridColumn: 2, gridRow: 1 }}
//                     key={i}
//                   >
//                     <div style={{ fontWeight: 800, fontSize: 14 }}>
//                       {fmt(d, { weekday: "short" })}{" "}
//                       <span style={{ fontWeight: 600, opacity: 0.85 }}>
//                         {fmt(d, { month: "short", day: "numeric" })}
//                       </span>
//                     </div>
//                   </div>
//                 );
//               })()
//             : dayIndices.map((i) => (
//                 <div
//                   key={i}
//                   style={{ ...sx.dayHeader, gridColumn: i + 2, gridRow: 1 }}
//                 >
//                   <div style={{ fontWeight: 800, fontSize: 14 }}>
//                     {fmt(days[i], { weekday: "short" })}{" "}
//                     <span style={{ fontWeight: 600, opacity: 0.85 }}>
//                       {fmt(days[i], { month: "short", day: "numeric" })}
//                     </span>
//                   </div>
//                 </div>
//               ))}

//           {/* Time labels (every 30 minutes) aligned to 15-min grid rows */}
//           {timeLabels.map(({ label, row }, idx) => (
//             <div
//               key={idx}
//               style={{ ...sx.timeCell, gridColumn: 1, gridRow: row }}
//             >
//               {label}
//             </div>
//           ))}

//           {/* Grid background cells */}
//           {dayIndices.map((dayIdx) =>
//             Array.from({ length: rowsCount }).map((__, r) => (
//               <div
//                 key={`cell-${dayIdx}-${r}`}
//                 style={{
//                   gridColumn: isMobile ? 2 : dayIdx + 2,
//                   gridRow: r + 2,
//                   borderBottom: "1px solid #eef2f7",
//                   borderRight:
//                     !isMobile && dayIdx < 6
//                       ? "1px solid #f3f5f9"
//                       : "none",
//                 }}
//               />
//             ))
//           )}

//           {/* Booking blocks with side-by-side overlaps */}
//           {laidOutBookings
//             .filter((item) =>
//               isMobile ? item.dayIndex === selectedDayIndex : true
//             )
//             .map((item) => {
//               const { booking: b, dayIndex, rowStart, rowEnd, colIndex, colsTotal } =
//                 item;

//               const widthPercent = 100 / colsTotal;
//               const translatePercent = 100 * colIndex; // in terms of own width

//               return (
//                 <div
//                   key={b.id}
//                   title={`${b.title} • ${b.staff.name}`}
//                   style={{
//                     ...sx.booking,
//                     ...(isMobile ? sx.bookingMobile : {}),
//                     gridColumn: isMobile ? 2 : dayIndex + 2,
//                     gridRow: `${rowStart} / ${rowEnd}`,
//                     background: b.color || "#5c5470",
//                     width: `calc(${widthPercent}% - 4px)`,
//                     transform: `translateX(${translatePercent}%)`,
//                     zIndex: 1 + colIndex,
//                   }}
//                 >
//                   <div style={sx.bTitle}>{b.title}</div>
//                   <div style={sx.bMeta}>
//                     {fmtTime(b._start)} – {fmtTime(b._end)}
//                   </div>
//                   <div style={sx.bStaff}>{b.staff.name}</div>
//                 </div>
//               );
//             })}
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ---------------- Booking layout (overlaps) ---------------- */

// /**
//  * For each day, assign overlapping bookings to "columns" so they can be
//  * rendered side-by-side.
//  */
// function layoutBookings(bookings, weekStart) {
//   const byDay = new Map();

//   bookings.forEach((b) => {
//     const s = b._start;
//     const e = b._end;
//     if (!(s instanceof Date) || !(e instanceof Date)) return;
//     if (isNaN(s) || isNaN(e)) return;

//     const dayIndex = Math.floor(
//       (stripTime(s) - stripTime(weekStart)) / (24 * 3600 * 1000)
//     );
//     if (dayIndex < 0 || dayIndex > 6) return;

//     const startSlots = Math.round(minutesSinceStart(s) / SLOT_MIN);
//     const endSlots = Math.round(minutesSinceStart(e) / SLOT_MIN);
//     const rowStart = 2 + startSlots;
//     const rowEnd = 2 + endSlots;
//     if (rowEnd <= rowStart) return;

//     const item = {
//       booking: b,
//       dayIndex,
//       rowStart,
//       rowEnd,
//       startSlots,
//       endSlots,
//     };
//     if (!byDay.has(dayIndex)) byDay.set(dayIndex, []);
//     byDay.get(dayIndex).push(item);
//   });

//   const laidOut = [];

//   for (const [dayIndex, list] of byDay.entries()) {
//     // sort by start time, then by end
//     list.sort(
//       (a, b) =>
//         a.startSlots - b.startSlots || a.endSlots - b.endSlots
//     );

//     const columnsEnd = []; // last endSlots per column index

//     list.forEach((item) => {
//       let col = 0;
//       // find first column that is free (no overlap)
//       while (col < columnsEnd.length && item.startSlots < columnsEnd[col]) {
//         col++;
//       }
//       if (col === columnsEnd.length) {
//         columnsEnd.push(item.endSlots);
//       } else {
//         columnsEnd[col] = item.endSlots;
//       }
//       item.colIndex = col;
//     });

//     const colsTotal = columnsEnd.length || 1;

//     list.forEach((item) => {
//       laidOut.push({
//         booking: item.booking,
//         dayIndex,
//         rowStart: item.rowStart,
//         rowEnd: item.rowEnd,
//         colIndex: item.colIndex,
//         colsTotal,
//       });
//     });
//   }

//   return laidOut;
// }

// /* ---------------- Date utilities & labels ---------------- */

// function placeDummy() {} // (unused now, kept only so diff is clearer)

// function minutesSinceStart(d) {
//   return (d.getHours() - START_HOUR) * 60 + d.getMinutes();
// }

// // Build 30-min labels and which grid row each should be rendered at
// function makeHalfHourLabels(fromHour, toHour) {
//   const labels = [];
//   const base = stripTime(new Date());
//   for (let h = fromHour; h < toHour; h++) {
//     for (let m of [0, 30]) {
//       const dt = new Date(base);
//       dt.setHours(h, m, 0, 0);
//       const minutes = (h - START_HOUR) * 60 + m;
//       const row = 2 + Math.round(minutes / SLOT_MIN); // 15-min grid
//       labels.push({ label: fmtTime(dt), row });
//     }
//   }
//   // add the final 10:00 PM label
//   const end = new Date(base);
//   end.setHours(toHour, 0, 0, 0);
//   labels.push({
//     label: fmtTime(end),
//     row: 2 + Math.round(((toHour - START_HOUR) * 60) / SLOT_MIN),
//   });
//   return labels;
// }

// function getMonday(d) {
//   const x = new Date(d);
//   const day = (x.getDay() + 6) % 7; // Mon=0
//   x.setDate(x.getDate() - day);
//   x.setHours(0, 0, 0, 0);
//   return x;
// }
// function addDays(d, n) {
//   const x = new Date(d);
//   x.setDate(x.getDate() + n);
//   return x;
// }
// function stripTime(d) {
//   const x = new Date(d);
//   x.setHours(0, 0, 0, 0);
//   return x;
// }
// function fmt(d, opt) {
//   return new Intl.DateTimeFormat(undefined, opt).format(d);
// }

// // Force 12-hour display (1:45 PM) to match your UI
// function fmtTime(d) {
//   return new Intl.DateTimeFormat(undefined, {
//     hour: "numeric",
//     minute: "2-digit",
//     hour12: true,
//   }).format(d);
// }

// // Convert local date (00:00) to a UTC-midnight Date
// function toUTCMidnight(localDate) {
//   const y = localDate.getFullYear();
//   const m = localDate.getMonth();
//   const d = localDate.getDate();
//   return new Date(Date.UTC(y, m, d, 0, 0, 0, 0));
// }

// /* ---------------- Colors ---------------- */

// const PALETTE = [
//   "#6b60a1",
//   "#c98f7a",
//   "#7aa3c9",
//   "#86b17e",
//   "#a967a0",
//   "#5c5470",
// ];
// function colorForEmployee(empId) {
//   const key = String(empId || "na");
//   let hash = 0;
//   for (let i = 0; i < key.length; i++)
//     hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
//   return PALETTE[hash % PALETTE.length];
// }

// /* ---------------- Styles ---------------- */

// const sx = {
//   screen: {
//     minHeight: "100vh",
//     background: "#f8fafc",
//     fontFamily:
//       "Work Sans, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
//   },
//   header: {
//     maxWidth: 1200,
//     margin: "0 auto",
//     padding: "16px 20px",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//   },
//   brand: { fontSize: 20, fontWeight: 800, color: "#5c5470" },
//   nav: { display: "flex", gap: 8 },
//   navBtn: {
//     background: "#e7e9ee",
//     border: 0,
//     borderRadius: 8,
//     padding: "8px 10px",
//     cursor: "pointer",
//     fontWeight: 700,
//     color: "#475569",
//   },

//   // mobile day strip
//   dayStrip: {
//     maxWidth: 1200,
//     margin: "0 auto",
//     padding: "0 12px 6px",
//     display: "flex",
//     gap: 6,
//     overflowX: "auto",
//   },
//   dayChip: {
//     minWidth: 40,
//     padding: "6px 4px",
//     borderRadius: 999,
//     border: "0",
//     background: "#e5e7eb",
//     color: "#111827",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     fontSize: 11,
//     fontWeight: 600,
//   },
//   dayChipActive: {
//     background: "#5c5470",
//     color: "#fff",
//   },
//   dayChipDow: { fontSize: 10, opacity: 0.9 },
//   dayChipDate: { fontSize: 13, fontWeight: 800, marginTop: 2 },

//   weekLabel: {
//     maxWidth: 1200,
//     margin: "0 auto",
//     padding: "0 20px 10px",
//     fontWeight: 700,
//     color: "#0f172a",
//   },
//   weekLabelMobile: {
//     padding: "0 16px 8px",
//     fontSize: 13,
//   },

//   calendarWrapDesktop: {
//     maxWidth: 1200,
//     margin: "0 auto",
//     padding: "0 20px 40px",
//   },
//   calendarWrapMobile: {
//     maxWidth: "100%",
//     margin: "0 auto",
//     padding: "0 12px 32px",
//     overflowX: "auto",
//   },

//   grid: {
//     position: "relative",
//     display: "grid",
//     background: "#fff",
//     border: "1px solid #e5e7eb",
//     borderRadius: 12,
//     overflow: "hidden",
//     boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
//   },
//   gridMobile: {
//     minWidth: 360,
//   },

//   dayHeader: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     borderLeft: "1px solid #eef2f7",
//     background: "#fafbfe",
//     color: "#0f172a",
//   },
//   timeCell: {
//     paddingRight: 8,
//     paddingLeft: 8,
//     fontSize: 11,
//     color: "#64748b",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "flex-end",
//     borderBottom: "1px solid #eef2f7",
//     background: "#fafbfe",
//   },
//   booking: {
//     position: "relative",
//     margin: "2px 6px",
//     borderRadius: 8,
//     color: "#fff",
//     padding: "8px 10px",
//     boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
//     overflow: "hidden",
//   },
//   bookingMobile: {
//     padding: "6px 8px",
//   },
//   bTitle: { fontSize: 12, fontWeight: 800, lineHeight: 1.2 },
//   bMeta: { fontSize: 11, opacity: 0.95, marginTop: 2 },
//   bStaff: {
//     fontSize: 11,
//     fontWeight: 700,
//     marginTop: 6,
//     paddingTop: 6,
//     borderTop: "1px dashed rgba(255,255,255,0.5)",
//   },
// };

// src/pages/public/WeeklyCalendar.jsx
import React, { useEffect, useMemo, useState } from "react";
import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
  Timestamp,
} from "firebase/firestore";
import { db } from "../../config/firebase";

const START_HOUR = 8;  // 8 AM
const END_HOUR   = 22; // 10 PM
const SLOT_MIN   = 15;
const ROW_HEIGHT = 28;

/* --- simple mobile hook --- */
function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= breakpoint : false
  );

  useEffect(() => {
    const handler = () => {
      if (typeof window === "undefined") return;
      setIsMobile(window.innerWidth <= breakpoint);
    };
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, [breakpoint]);

  return isMobile;
}

export default function WeeklyCalendar() {
  const [weekStart, setWeekStart] = useState(getMonday(new Date()));
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const isMobile = useIsMobile();

  // selected day index on mobile
  const [selectedDayIndex, setSelectedDayIndex] = useState(() => {
    const today = new Date();
    const monday = getMonday(today);
    const diff =
      (stripTime(today) - stripTime(monday)) / (24 * 3600 * 1000);
    return diff >= 0 && diff < 7 ? Math.floor(diff) : 0;
  });

  // grid rows for desktop (15-min slots)
  const rowsCount = useMemo(
    () => ((END_HOUR - START_HOUR) * 60) / SLOT_MIN,
    []
  );

  const days = useMemo(
    () => Array.from({ length: 7 }, (_, i) => addDays(weekStart, i)),
    [weekStart]
  );

  const timeLabels = useMemo(
    () => makeHalfHourLabels(START_HOUR, END_HOUR),
    []
  );

  // Firestore subscription
  useEffect(() => {
    if (!db) return;

    const startUTC = toUTCMidnight(weekStart);
    const endUTC   = toUTCMidnight(addDays(weekStart, 7));

    const q = query(
      collection(db, "bookings"),
      where("start", ">=", Timestamp.fromDate(startUTC)),
      where("start", "<",  Timestamp.fromDate(endUTC)),
      orderBy("start", "asc")
    );

    setLoading(true);
    const unsub = onSnapshot(
      q,
      (snap) => {
        const items = snap.docs
          .map((d) => {
            const x = d.data() || {};
            const start =
              x.start?.toDate?.() ?? (x.start ? new Date(x.start) : null);
            const end =
              x.end?.toDate?.() ?? (x.end ? new Date(x.end) : null);

            if (
              !(start instanceof Date) ||
              isNaN(start) ||
              !(end instanceof Date) ||
              isNaN(end)
            ) {
              return null;
            }

            let title = "Service";
            if (Array.isArray(x.services) && x.services.length) {
              const names = x.services
                .map((s) => s?.name || "Service")
                .filter(Boolean);
              title =
                names.length > 1
                  ? `${names[0]} (+${names.length - 1})`
                  : names[0];
            } else if (x.serviceName || x.service) {
              title = x.serviceName || x.service;
            }

            const sid = x.staffId || x.employeeId || "na";
            const sname =
              x.staffName ||
              x.employeeName ||
              (sid === "any" ? "Any staff" : "Staff");

            return {
              id: d.id,
              title,
              staff: { id: sid, name: sname },
              _start: start,
              _end: end,
              color: colorForEmployee(sid),
            };
          })
          .filter(Boolean);
        setBookings(items);
        setLoading(false);
      },
      (err) => {
        console.error("Bookings subscription failed:", err);
        setLoading(false);
      }
    );

    return () => unsub();
  }, [weekStart]);

  /* ---------- shared callbacks ---------- */

  const handleThisWeek = () => {
    const today  = new Date();
    const monday = getMonday(today);
    setWeekStart(monday);
    const diff =
      (stripTime(today) - stripTime(monday)) / (24 * 3600 * 1000);
    setSelectedDayIndex(diff >= 0 && diff < 7 ? Math.floor(diff) : 0);
  };

  /* ================= MOBILE LAYOUT (LIST) ================= */

  if (isMobile) {
    const bookingsForDay = bookings
      .map((b) => {
        const dayIndex = Math.floor(
          (stripTime(b._start) - stripTime(weekStart)) /
            (24 * 3600 * 1000)
        );
        return { ...b, dayIndex };
      })
      .filter((b) => b.dayIndex === selectedDayIndex)
      .sort((a, b) => a._start - b._start); // order of appearance

    return (
      <div style={sx.screen}>
        <div style={sx.header}>
          <div style={sx.brand}>Schedule</div>
          <div style={sx.nav}>
            <button
              style={sx.navBtn}
              onClick={() => setWeekStart(addDays(weekStart, -7))}
            >
              ← Prev
            </button>
            <button style={sx.navBtn} onClick={handleThisWeek}>
              Today
            </button>
            <button
              style={sx.navBtn}
              onClick={() => setWeekStart(addDays(weekStart, 7))}
            >
              Next →
            </button>
          </div>
        </div>

        {/* Day strip like Teams */}
        <div style={sx.dayStrip}>
          {days.map((d, i) => {
            const active = i === selectedDayIndex;
            return (
              <button
                key={i}
                style={{
                  ...sx.dayChip,
                  ...(active ? sx.dayChipActive : {}),
                }}
                onClick={() => setSelectedDayIndex(i)}
              >
                <div style={sx.dayChipDow}>
                  {fmt(d, { weekday: "short" }).slice(0, 1)}
                </div>
                <div style={sx.dayChipDate}>{d.getDate()}</div>
              </button>
            );
          })}
        </div>

        <div
          style={{
            ...sx.weekLabel,
            ...sx.weekLabelMobile,
          }}
        >
          {fmt(days[selectedDayIndex], {
            weekday: "long",
            month: "short",
            day: "numeric",
            year: "numeric",
          })}
          {loading ? " • loading…" : ""}
        </div>

        {/* Cards list */}
        <div style={sx.mobileListWrap}>
          {bookingsForDay.length === 0 && !loading && (
            <div style={sx.mobileEmpty}>No bookings for this day.</div>
          )}
          {bookingsForDay.map((b) => (
            <div key={b.id} style={sx.mobileCard}>
              <div style={sx.mobileTitle}>{b.title}</div>
              <div style={sx.mobileTime}>
                {fmtTime(b._start)} – {fmtTime(b._end)}
              </div>
              <div style={sx.mobileStaff}>{b.staff.name}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  /* ================= DESKTOP LAYOUT (GRID) ================= */

  // For desktop, compute placement and duration so we can control z-order
  const placements = bookings
    .map((b) => {
      const pos = placeBooking(b, weekStart);
      if (pos.col < 0) return null;
      const durationMinutes = (b._end - b._start) / 60000;
      return { b, pos, durationMinutes };
    })
    .filter(Boolean);

  // render long bookings first, short ones later so short are "on top"
  placements.sort((a, b) => b.durationMinutes - a.durationMinutes);

  return (
    <div style={sx.screen}>
      <div style={sx.header}>
        <div style={sx.brand}>Weekly Schedule</div>
        <div style={sx.nav}>
          <button
            style={sx.navBtn}
            onClick={() => setWeekStart(addDays(weekStart, -7))}
          >
            ← Prev
          </button>
          <button style={sx.navBtn} onClick={handleThisWeek}>
            This Week
          </button>
          <button
            style={sx.navBtn}
            onClick={() => setWeekStart(addDays(weekStart, 7))}
          >
            Next →
          </button>
        </div>
      </div>

      <div style={sx.weekLabel}>
        {fmt(days[0], { month: "short", day: "numeric" })} –{" "}
        {fmt(days[6], { month: "short", day: "numeric", year: "numeric" })}
        {loading ? " • loading…" : ""}
      </div>

      <div style={sx.calendarWrapDesktop}>
        <div
          style={{
            ...sx.grid,
            gridTemplateColumns: `140px repeat(7, 1fr)`,
            gridTemplateRows: `40px repeat(${rowsCount}, ${ROW_HEIGHT}px)`,
          }}
        >
          {/* top-left corner */}
          <div style={{ gridColumn: 1, gridRow: 1 }} />

          {/* day headers */}
          {days.map((d, i) => (
            <div
              key={i}
              style={{ ...sx.dayHeader, gridColumn: i + 2, gridRow: 1 }}
            >
              <div style={{ fontWeight: 800, fontSize: 14 }}>
                {fmt(d, { weekday: "short" })}{" "}
                <span style={{ fontWeight: 600, opacity: 0.85 }}>
                  {fmt(d, { month: "short", day: "numeric" })}
                </span>
              </div>
            </div>
          ))}

          {/* time labels */}
          {timeLabels.map(({ label, row }, idx) => (
            <div
              key={idx}
              style={{ ...sx.timeCell, gridColumn: 1, gridRow: row }}
            >
              {label}
            </div>
          ))}

          {/* grid background */}
          {days.map((_, c) =>
            Array.from({ length: rowsCount }).map((__, r) => (
              <div
                key={`cell-${c}-${r}`}
                style={{
                  gridColumn: c + 2,
                  gridRow: r + 2,
                  borderBottom: "1px solid #eef2f7",
                  borderRight: c < 6 ? "1px solid #f3f5f9" : "none",
                }}
              />
            ))
          )}

          {/* bookings (overlaps vertical; shorter on top) */}
          {placements.map((p, idx) => (
            <div
              key={p.b.id}
              title={`${p.b.title} • ${p.b.staff.name}`}
              style={{
                ...sx.booking,
                gridColumn: p.pos.col,
                gridRow: `${p.pos.rowStart} / ${p.pos.rowEnd}`,
                background: p.b.color || "#5c5470",
                zIndex: 1 + idx, // later in array = higher z-index
              }}
            >
              <div style={sx.bTitle}>{p.b.title}</div>
              <div style={sx.bMeta}>
                {fmtTime(p.b._start)} – {fmtTime(p.b._end)}
              </div>
              <div style={sx.bStaff}>{p.b.staff.name}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ---------------- Placement & Labels (desktop) ---------------- */

function placeBooking(b, weekStart) {
  if (!b || !(b._start instanceof Date) || !(b._end instanceof Date))
    return { col: -1 };
  const s = b._start;
  const e = b._end;
  if (isNaN(s) || isNaN(e)) return { col: -1 };

  const dayIndex = Math.floor(
    (stripTime(s) - stripTime(weekStart)) / (24 * 3600 * 1000)
  );
  if (dayIndex < 0 || dayIndex > 6) return { col: -1 };

  const startSlots = Math.round(minutesSinceStart(s) / SLOT_MIN);
  const endSlots   = Math.round(minutesSinceStart(e) / SLOT_MIN);

  const rowStart = 2 + startSlots;
  const rowEnd   = 2 + endSlots;
  const col      = dayIndex + 2;

  return { col, rowStart, rowEnd };
}

function minutesSinceStart(d) {
  return (d.getHours() - START_HOUR) * 60 + d.getMinutes();
}

function makeHalfHourLabels(fromHour, toHour) {
  const labels = [];
  const base = stripTime(new Date());
  for (let h = fromHour; h < toHour; h++) {
    for (let m of [0, 30]) {
      const dt = new Date(base);
      dt.setHours(h, m, 0, 0);
      const minutes = (h - START_HOUR) * 60 + m;
      const row = 2 + Math.round(minutes / SLOT_MIN);
      labels.push({ label: fmtTime(dt), row });
    }
  }
  const end = new Date(base);
  end.setHours(toHour, 0, 0, 0);
  labels.push({
    label: fmtTime(end),
    row: 2 + Math.round(((toHour - START_HOUR) * 60) / SLOT_MIN),
  });
  return labels;
}

/* ---------------- Date utilities ---------------- */

function getMonday(d) {
  const x = new Date(d);
  const day = (x.getDay() + 6) % 7; // Mon=0
  x.setDate(x.getDate() - day);
  x.setHours(0, 0, 0, 0);
  return x;
}
function addDays(d, n) {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
}
function stripTime(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}
function fmt(d, opt) {
  return new Intl.DateTimeFormat(undefined, opt).format(d);
}
function fmtTime(d) {
  return new Intl.DateTimeFormat(undefined, {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(d);
}
function toUTCMidnight(localDate) {
  const y = localDate.getFullYear();
  const m = localDate.getMonth();
  const d = localDate.getDate();
  return new Date(Date.UTC(y, m, d, 0, 0, 0, 0));
}

/* ---------------- Colors ---------------- */

const PALETTE = [
  "#6b60a1",
  "#c98f7a",
  "#7aa3c9",
  "#86b17e",
  "#a967a0",
  "#5c5470",
];
function colorForEmployee(empId) {
  const key = String(empId || "na");
  let hash = 0;
  for (let i = 0; i < key.length; i++)
    hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  return PALETTE[hash % PALETTE.length];
}

/* ---------------- Styles ---------------- */

const sx = {
  screen: {
    minHeight: "100vh",
    background: "#f8fafc",
    fontFamily:
      "Work Sans, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
  },
  header: {
    maxWidth: 1200,
    margin: "0 auto",
    padding: "16px 20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  brand: { fontSize: 20, fontWeight: 800, color: "#5c5470" },
  nav: { display: "flex", gap: 8 },
  navBtn: {
    background: "#e7e9ee",
    border: 0,
    borderRadius: 8,
    padding: "8px 10px",
    cursor: "pointer",
    fontWeight: 700,
    color: "#475569",
  },

  weekLabel: {
    maxWidth: 1200,
    margin: "0 auto",
    padding: "0 20px 10px",
    fontWeight: 700,
    color: "#0f172a",
  },
  weekLabelMobile: {
    padding: "0 16px 8px",
    fontSize: 13,
  },

  /* desktop grid */
  calendarWrapDesktop: {
    maxWidth: 1200,
    margin: "0 auto",
    padding: "0 20px 40px",
  },
  grid: {
    position: "relative",
    display: "grid",
    background: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: 12,
    overflow: "hidden",
    boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
  },
  dayHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderLeft: "1px solid #eef2f7",
    background: "#fafbfe",
    color: "#0f172a",
  },
  timeCell: {
    paddingRight: 8,
    paddingLeft: 8,
    fontSize: 11,
    color: "#64748b",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    borderBottom: "1px solid #eef2f7",
    background: "#fafbfe",
  },
  booking: {
    position: "relative",
    margin: "2px 6px",
    borderRadius: 8,
    color: "#fff",
    padding: "8px 10px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
    overflow: "hidden",
  },
  bTitle: { fontSize: 12, fontWeight: 800, lineHeight: 1.2 },
  bMeta: { fontSize: 11, opacity: 0.95, marginTop: 2 },
  bStaff: {
    fontSize: 11,
    fontWeight: 700,
    marginTop: 6,
    paddingTop: 6,
    borderTop: "1px dashed rgba(255,255,255,0.5)",
  },

  /* mobile day strip + list */
  dayStrip: {
    maxWidth: 1200,
    margin: "0 auto",
    padding: "0 12px 6px",
    display: "flex",
    gap: 6,
    overflowX: "auto",
  },
  dayChip: {
    minWidth: 40,
    padding: "6px 4px",
    borderRadius: 999,
    border: 0,
    background: "#e5e7eb",
    color: "#111827",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 11,
    fontWeight: 600,
  },
  dayChipActive: {
    background: "#5c5470",
    color: "#fff",
  },
  dayChipDow: { fontSize: 10, opacity: 0.9 },
  dayChipDate: { fontSize: 13, fontWeight: 800, marginTop: 2 },

  mobileListWrap: {
    maxWidth: 1200,
    margin: "0 auto",
    padding: "0 12px 24px",
  },
  mobileEmpty: {
    padding: "12px 8px",
    fontSize: 13,
    color: "#6b7280",
  },
  mobileCard: {
    background: "#fff",
    borderRadius: 12,
    padding: "10px 12px",
    marginBottom: 10,
    boxShadow: "0 1px 3px rgba(15,23,42,0.06)",
    border: "1px solid #e5e7eb",
  },
  mobileTitle: {
    fontSize: 14,
    fontWeight: 700,
    marginBottom: 4,
    color: "#111827",
  },
  mobileTime: {
    fontSize: 13,
    color: "#4b5563",
  },
  mobileStaff: {
    fontSize: 12,
    color: "#6b7280",
    marginTop: 4,
    fontWeight: 600,
  },
};
